import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import axios from '../../axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import './LoginForm.scss';
import logo from '../../img/nekrodruk-logo-dark.png';
import { useAuth } from '../../context/AuthContext';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Link,
  Stack,
  Alert,
} from '@mui/material';
import PasswordTextField from '../PasswordTextField';



export default function LoginForm() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const { isLoggedIn, setIsLoggedIn, refreshAuth, needsConsents } = useAuth();
  useEffect(() => {
    if (isLoggedIn) {
      navigate(needsConsents ? '/consents' : '/personForm');
    }
  }, [isLoggedIn, needsConsents, navigate]);

  const initialValues = {
    login: '',
    password: '',
  };

  const validationSchema = Yup.object({
    login: Yup.string().required('Login jest wymagany'),
    password: Yup.string().required('Hasło jest wymagane'),
  });

  const handleLogin = async (values, { setSubmitting }) => {
    const { login, password } = values;
    setError('');
    try {
      const response = await axios.post('/login', {
        login,
        password
      });
      const token = response.data.token;
      localStorage.setItem('token', token);
      
      setIsLoggedIn(true);

      try {
        const authData = await refreshAuth();
        const targetPath = authData?.needsConsents ? '/consents' : '/personForm';
        navigate(targetPath);
      } catch (refreshError) {
        console.error('Nie udało się odświeżyć danych użytkownika po zalogowaniu:', refreshError);
        navigate('/personForm');
      }
    } catch (error) {
      setError('Niepoprawny login lub hasło');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box className='LoginForm'>
      <Paper elevation={0} className='formCard'>
        <Stack spacing={3} alignItems='center'>
          <Box component='img' src={logo} alt='nekrodruk logo' className='logo' />
          <Typography component='h1' variant='h4' className='formTitle'>
            Logowanie
          </Typography>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form className='formContainer'>
                <Stack spacing={2} width='100%'>
                  <Field name='login'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        type='email'
                        label='Adres e-mail'
                        variant='outlined'
                        fullWidth
                        error={Boolean(meta.touched && meta.error)}
                        helperText={meta.touched && meta.error ? meta.error : ''}
                      />
                    )}
                  </Field>
                  <Field name='password'>
                    {({ field, meta }) => (
                      <PasswordTextField
                        {...field}
                        label='Hasło'
                        variant='outlined'
                        fullWidth
                        error={Boolean(meta.touched && meta.error)}
                        helperText={meta.touched && meta.error ? meta.error : ''}
                      />
                    )}
                  </Field>
                  {error && (
                    <Alert severity='error' className='formAlert'>
                      {error}
                    </Alert>
                  )}
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    disabled={isSubmitting}
                    className='formSubmit'
                  >
                    Zaloguj się
                  </Button>
                  <Link component={RouterLink} to='/forgot-password' align='center'>
                    Nie pamiętasz hasła?
                  </Link>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </Paper>
    </Box>
  );
};

